import { forwardRef, useState, useCallback } from "react";
import { motion } from "framer-motion";
import { springs } from "../motion";
import type { InputProps } from "./types";

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { icon: Icon, className = "", onFocus, onBlur, ...rest },
  ref,
) {
  const [focused, setFocused] = useState(false);

  const handleFocus = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      setFocused(true);
      onFocus?.(e);
    },
    [onFocus],
  );

  const handleBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      setFocused(false);
      onBlur?.(e);
    },
    [onBlur],
  );

  return (
    <motion.div
      className={`flex items-center rounded-button border bg-card ${className}`}
      animate={{
        borderColor: focused ? "var(--color-accent)" : "var(--color-border)",
        boxShadow: focused
          ? "0 0 0 3px var(--color-accent-soft)"
          : "0 0 0 0px transparent",
      }}
      transition={springs.snappy}
    >
      {Icon && (
        <Icon className="ml-3 h-4 w-4 shrink-0 text-muted" strokeWidth={1.8} />
      )}
      <input
        ref={ref}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className="h-9 w-full bg-transparent px-2.5 text-[14px] font-normal text-primary placeholder:text-muted outline-none"
        {...rest}
      />
    </motion.div>
  );
});
